<div class="inputs">
  <div cdkOverlayOrigin #formField="cdkOverlayOrigin" class="cdk-overlay-wrapper">
    <input class="input" #searchBar (focus)="onFocus()" (keyup)="onKeyup()" placeholder="start typing a name..." />
    @if (searchBar.value) {
    <button class="iconf-btn-blank clear" matSuffix aria-label="Clear" (click)="clearSearchField()">
      <mat-icon>close</mat-icon>
    </button>
    }
  </div>
</div>
<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="formField" [cdkConnectedOverlayOpen]="overlayOpen" #overlayContainer>
  <div #userListWrapper>
    <mat-selection-list [class.mat-elevation-z2]="true" (selectionChange)="onSelection($event)" [multiple]="false">
      @for (user of users$ | async; track user) {
      <mat-list-option [value]="user" class="user-list">
        <span class="display-name">{{ user.displayName }}</span>
        <span class="email">{{ user.userPrincipalName }}</span>
      </mat-list-option>
      }
    </mat-selection-list>
  </div>
</ng-template>
